import { render } from "./activityScale.vue?vue&type=template&id=baf279b2&scoped=true"
import script from "./activityScale.vue?vue&type=script&lang=js"
export * from "./activityScale.vue?vue&type=script&lang=js"

import "./activityScale.vue?vue&type=style&index=0&id=baf279b2&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-baf279b2"]])

export default __exports__